export default {
  allUsers: [],
  staffCheckInModal: false,
  staffCheckOutModal: false,
}
